import seca20 from '/public/images/trainings/secaem20.webp'
import power20 from '/public/images/trainings/power20.webp'
import cardioDance from '/public/images/trainings/cardiodance.webp'
import barrigaDefinida from '/public/images/trainings/barrigadefinida.webp'
import aulasYoga from '/public/images/trainings/aulas-yoga.webp'
import fogueteFight from '/public/images/trainings/foguetefight.webp'
import metodoLapa from '/public/images/trainings/metodolapateam.webp'

export const TRAININGS = [
  {
    id: 'cardio',
    imageName: 'cardiodance.webp',
    imageUrl: cardioDance,
    alt: 'Cardio Dance com Melissa',
    description: (
      <>
        <p>Treinos de Cardio com a dinâmica de uma Aula de Dança</p>
        <p>Faça de qualquer lugar: sem necessidade de equipamentos</p>
        <p>Queime gordura se expressando com seu corpo através da Dança</p>
        <p>
          Treinos Ao Vivo toda semana e Novos treinos gravados todos os meses
        </p>
      </>
    )
  },
  {
    id: 'barriga-definida',
    imageName: 'barrigadefinida.webp',
    imageUrl: barrigaDefinida,
    alt: 'Barriga denifida entenda a técnica',
    description: (
      <>
        <p>Treinos específicos para você secar e definir seu Abdômen</p>
        <p>
          Aprenda a fazer o Vácuo Abdominal e as principais técnicas de
          respiração
        </p>
        <p>Faça de qualquer lugar: sem necessidade de equipamentos</p>
        <p>
          Sequência de treinos específicas para você não ficar perdida em nenhum
          momento
        </p>
      </>
    )
  },
  {
    id: 'seca20',
    imageName: 'secaem20.webp',
    imageUrl: seca20,
    alt: 'Seca em 20 minutos, emagrecimento / superiores',
    description: (
      <>
        <p>Treinos de até 20 minutos focados em emagrecimento</p>
        <p>Faça de qualquer lugar: sem necessidade de equipamentos</p>
        <p>Aulas dividas com foco em Superiores ou Inferiores</p>
        <p>Novos treinos todos os meses</p>
      </>
    )
  },
  {
    id: 'foguete-fight',
    imageName: 'foguete-fight.webp',
    imageUrl: fogueteFight,
    alt: 'Cardio Boxe iniciante',
    description: (
      <>
        <p>
          Treinos dinâmicos com técnicas de socos, chutes e movimentos de pernas
          que trabalha o corpo todo
        </p>
        <p>Faça de qualquer lugar: sem necessidade de equipamentos</p>
        <p>
          Treinos Ao Vivo toda semana e Novos treinos gravados todos os meses
        </p>
      </>
    )
  },
  {
    id: 'yoga',
    imageName: 'aulas-yoga.webp',
    imageUrl: aulasYoga,
    alt: 'Aulas de Yoga',
    description: (
      <>
        <p>Aulas de Yoga para você evoluir por completo: mente, alma e corpo</p>
        <p>Aulas Ao Vivo toda semana e Novas Aulas gravadas todos os meses</p>
        <p>Faça de qualquer lugar: sem necessidade de equipamentos</p>
        <p>
          Aulas de Mindfulness, Yoga Flow, Yoga para Mobilidade, Hatha Yoga e
          diversas outras modalidades
        </p>
      </>
    )
  },
  {
    id: 'metodo-lapa',
    imageName: 'metodolapateam.webp',
    imageUrl: metodoLapa,
    alt: 'Método Lapa Team',
    description: (
      <>
        <p>
          O método de treino exclusivo que você só encontra na Academia Foguete
        </p>
        <p>Criado pelo nosso Fundador Ricardo Lapa</p>
        <p>Combina treinamento funcional e intensivo</p>
        <p>Faça de qualquer lugar: sem necessidade de equipamentos</p>
      </>
    )
  },
  {
    id: 'power20',
    imageName: 'power20.webp',
    imageUrl: power20,
    alt: 'Treinos curtos e intensos',
    description: (
      <>
        <p>Treinos de até 20 minutos focados em Hipertrofia Muscular</p>
        <p>
          Você escolhe: opções de treino apenas com o Peso do Corpo ou com
          Equipamentos Básicos (Halteres, Bands, Kettlebells)
        </p>
        <p>Aulas dividas com foco em Superiores ou Inferiores</p>
        <p>Novos treinos todos os meses</p>
      </>
    )
  }
]
